import Portfolio from './components/Portfolio';
import './styles/shapes.css';

function App() {
  return (
    <Portfolio />
  );
}

export default App;